import React, { useEffect, useState } from "react";
import { Button, Tag } from "antd";
import { CalendarOutlined, GiftOutlined, InboxOutlined } from "@ant-design/icons";
import type { GroceryPackage } from "../types";

const PACKAGE_CURRENCY = "NGN";

export type PackageCardProps = {
  groceryPackage: GroceryPackage;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onDeleteRequest: (id: number) => void;
};

const formatDate = (value?: string) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
};

export const PackageCard: React.FC<PackageCardProps> = ({
  groceryPackage,
  onView,
  onEdit,
  onDeleteRequest,
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const imageUrl = groceryPackage.image?.trim();
  const showImage = Boolean(imageUrl && !imageFailed);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  return (
    <div className="package-card">
      <div className="package-card-image">
        {showImage ? (
          <img
            src={imageUrl}
            alt={groceryPackage.name}
            className="package-card-image-img"
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="package-card-placeholder" aria-label="Package image placeholder">
            <GiftOutlined />
          </div>
        )}
      </div>

      <div className="package-card-body">
        <div className="package-card-info">
          <div className="package-card-title-row">
            <div className="package-card-name">{groceryPackage.name}</div>
            <Tag color={groceryPackage.is_active ? "success" : "default"}>
              {groceryPackage.is_active ? "Active" : "Inactive"}
            </Tag>
          </div>
          <div className="package-card-price">
            Market-based pricing
          </div>
          <div className="package-card-meta">
            <span>
              <CalendarOutlined /> {formatDate(groceryPackage.created_at)}
            </span>
            <span>
              <InboxOutlined /> {groceryPackage.items.length} items
            </span>
          </div>
          <div className="package-card-description">
            {groceryPackage.description}
          </div>
        </div>

        <div className="market-card-actions package-card-actions">
          <Button
            type="text"
            size="small"
            className="market-card-btn-view"
            onClick={() => onView(groceryPackage.id)}
          >
            View
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-edit"
            onClick={() => onEdit(groceryPackage.id)}
          >
            Edit
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-delete"
            onClick={() => onDeleteRequest(groceryPackage.id)}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
